import { DeliveryMode } from '../../../../../services/exports/Constants';

export default {
  header: 'Sospendi nuovi ordini',
  sections: {
    pause_orders: {
      title: 'Per quanto tempo sarai non disponibile?',
      description: 'Informeremo i clienti che al momento non accetti nuovi ordini',
    },
    order_methods: {
      title: 'I miei metodi di ordine',
      description: 'Attiva o disattiva i metodi con cui i clienti possono ordinare da te',
    },
    delivery_mode: {
      title: 'Metodi di consegna',
      description: 'Passa dalla tua rete corrieri alla nostra',
    },
  },
  form: {
    orders_paused_until: {
      options: {
        '10_min': '10 min',
        '15_min': '15 min',
        '20_min': '20 min',
        '25_min': '25 min',
        '1_hour': '1 ora',
        '2_hours': '2 ore',
        rest_of_day: 'Resto della giornata',
      },
    },
    has_standalone_delivery: {
      label: 'I miei corrieri',
    },
    has_external_delivery: {
      label: 'Rete corrieri {{provider}}',
    },
  },
  labels: {
    delivery_orders_off: 'Ordini con consegna disattivati',
    delivery_orders_on: 'Ordini con consegna attivati',
  },
  modals: {
    toggle_delivery: {
      [true]: {
        title: 'Sei sicuro di voler abilitare gli ordini con consegna?',
        description: '',
      },
      [false]: {
        title: 'Sei sicuro di voler disabilitare gli ordini con consegna?',
        description: '',
      },
    },
    switch_delivery_mode: {
      [DeliveryMode.Internal]: {
        title: 'Sei sicuro di voler passare ai tuoi corrieri?',
        description: '',
      },
      [DeliveryMode.External]: {
        title: 'Sei sicuro di voler passare ai corrieri {{provider}}?',
        description: '',
      },
    },
  },
  buttons: {
    confirm: 'Conferma',
    cancel: 'Annulla',
  },
  toasts: {
    failed_to_save_changes: 'Impossibile salvare le modifiche',
    changes_got_saved: 'Modifiche salvate con successo',
  },
};
